export default "__VITE_ASSET__CiIw7umJ__"